import React, { FC, memo } from 'react';

import Markdown from '@components/utils/Markdown';
import { Separator } from '@components/formStyles';

import { Container, Title } from './AboutUsStyle';

export interface AboutUsProps {
  description?: string;
}

const AboutUs: FC<AboutUsProps> = ({ description = '' }) => (
  <Container>
    <Title>Otel Hakkında</Title>
    <Separator />
    <Markdown text={description} />
  </Container>
);

export default memo(AboutUs);
